export const TOKEN_ACCESS_DECLINED = 'Token Access Declined'

export default function () {
  return this.sendEventWithCallback('push.token', {})
    .then(data => {
      // shortcut
      if (data.token) {
        return data.token
      }

      return Promise.reject(new Error(
        (data.token === false)
          ? TOKEN_ACCESS_DECLINED
          : this.ERROR_UNKNOWN
      ))
    })
}
